import { useEffect, useState } from 'react';
import { ModalContent, ModalFooter } from '@components/modal';
import { Alert } from '@trussworks/react-uswds';
import Icon from '@mdi/react';
import { mdiLoading } from '@mdi/js';

const WithdrawModal = ({ withdrawClick, projectName, requestType }) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsButtonDisabled(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  const saveText = isButtonDisabled ? (
    <span>
      <Icon focusable={false} path={mdiLoading} spin={1} size={0.8} className='margin-right-1' />
    </span>
  ) : (
    'Yes, Withdraw Request'
  );

  return (
    <ModalContent title='Confirm Withdraw'>
      <section className='modal-body'>
        <Alert className='margin-bottom-1' heading='IMPORTANT' headingLevel='h5' type='warning'>
          Once withdrawn, this request <span className='text-bold'>cannot be reopened or reused.</span>
        </Alert>
        <p className='margin-bottom-1'>Are you sure you want to withdraw this request?</p>
        <ul>
          <li>
            <span className='text-bold'>Request Type:</span> {requestType}
          </li>
          <li>
            <span className='text-bold'>Project Name:</span> {projectName}
          </li>
        </ul>
      </section>
      <ModalFooter
        onSave={withdrawClick}
        saveText={saveText}
        saveIsDisabled={isButtonDisabled}
        showCancelButton
        cancelText='No'
      />
    </ModalContent>
  );
};
export default WithdrawModal;
